<template>
    <div class="main">
        <div
          v-bind:style="{ height: '100px', 'background-color': '#fff' }"
        ></div>
        <HeaderComponent
            :text="$t('text.profile')"
            backgroundColor="#fff"
        />
        <Transition appear name="fade">
            <div class="menu-container">
                <b-tabs justified pills content-class="mt-3" style="color: #000;">
                    <b-tab :title="$t('text.users')">
                        <ProfileUserComponent style="margin-top:40px;" />
                    </b-tab>
                    <b-tab :title="$t('text.bookings')">
                        <ProfileBookingComponent style="margin-top: 40px;"/>
                    </b-tab>
                </b-tabs>
            </div>
        </Transition>
    </div>
</template>

<script>
import HeaderComponent from "../components/HeaderComponent.vue";
import ProfileBookingComponent from "../components/ProfileBookingComponent.vue";
import ProfileUserComponent from "../components/ProfileUserComponent.vue";

export default {
    name: "ProfilePage",
    components: {
        HeaderComponent,
        ProfileBookingComponent,
        ProfileUserComponent
    },
    mounted() {
        if (!(this.$store.getters.token_valid && this.$store.getters.isLoggedIn)) {
            this.$router.push({ name: 'login', query: { redirect: this.$router.currentRoute } });
        }
    }
};
</script>

<style scoped>
.main {
  height: 100%;
  background-color: #fff;
}

.menu-container {
    max-width: 860px;
    margin:auto;
    padding-right: 16px;
    padding-left: 16px;
}
</style>
